module.exports = __webpack_public_path__ + "static/img/bg2.8903a72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/bg2.png
// module id = tr8g
// module chunks = 1